export const ELEMENTS_DOWNLOAD_ERROR_PREFIX = 'Failed to download elements';
export const NETWORK_DOWNLOAD_ERROR_PREFIX = 'Failed to download network';
